/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pageMarket.vue?vue&type=template&id=5d29eb70"
import script from "./pageMarket.vue?vue&type=script&lang=js"
export * from "./pageMarket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports